import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-danvi-slider-desktop",
  templateUrl: "./danvi-slider-desktop.component.html",
  styleUrls: ["./danvi-slider-desktop.component.scss"],
})
export class DanviSliderDesktopComponent implements OnInit {
  slides = [
    { img: "assets/img/danvi/danvi_dsk_01.webp" },
    { img: "assets/img/danvi/danvi_dsk_02.webp" },
    { img: "assets/img/danvi/danvi_dsk_04.webp" },
    { img: "assets/img/danvi/danvi_dsk_03.webp" },
    { img: "assets/img/danvi/danvi_dsk_05.webp" },
  ];

  breakpoints = [
    {
      breakpoint: 9999,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0",
      },
    },
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0",
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0",
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0",
      },
    },
  ];

  slideConfig = {
    dots: true,
    responsive: this.breakpoints,
  };
  constructor() {}

  ngOnInit() {}
}
